import { actionTypes } from '../actions/shopping.action';
const initialState = {
    shopping: {
        data: []
    },
    error: {},
    success: false
}

const ShoppingReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.shopping.data = state.shopping.data.concat(payload.shopping.data)
        }

        return { ...state, ...payload }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default ShoppingReducer